export default function (el) {
  if (el === null) return false;

  const form = document.querySelector('.js-scroll-to-form-target');
  const cta = document.querySelector('.js-scroll-to-cta-target');

  if (form == null && cta == null) {
    el.classList.add('hidden');
    return false;
  }

  el.addEventListener('click', () => {
    if (form) {
      if (form.classList.contains('js-scroll-to-form-target-hero')) {
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth',
        });
      } else {
        document.querySelector('.js-scroll-to-form-target').scrollIntoView({
          behavior: 'smooth',
        });
      }
    }
    if (cta) {
      if (cta.classList.contains('js-scroll-to-cta-target-hero')) {
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth',
        });
      } else {
        document.querySelector('.js-scroll-to-cta-target').scrollIntoView({
          behavior: 'smooth',
        });
      }
    }
  });
}
